<div class="custom-select martial-main-outer responsive-mob date-ranges">
    <div class="martial-outer">
        <p *ngIf="!same">Displaying data from {{checkstartDate}} to {{checkendDate}}</p>
        <p *ngIf="same">Displaying data from {{checkstartDate}}</p>
    </div>  
    <div class="formdate-outer">
        <div class="from-date">
            <div class="custom-select">
                <div class="filter-parking header-filter new-arrow custom-lots">
                    <span class="parkings-lots">Parking Lots</span>
                    <p-dropdown [options]="parkingLotByStates" [(ngModel)]="selectedParkingLot" optionLabel="name"
                        optionValue="id" (onChange)="parkingLotByStatesFunc($event,false)"></p-dropdown>
                    <img src="../../../../assets/images/fill-dropdown.svg" alt=""/>
                </div>
                <span class="single-lines"></span>
            </div>
             <div class="filter-parking header-filter new-arrow date-tooltip-outer">
                <span class="date-tooltip"><span class="tooltip-text"><app-tooltip [tooltipMessage]="dateRangeMessage"></app-tooltip></span>Date Range</span>
                <p-dropdown [options]="dateRangeOption" [(ngModel)]="dateRangeValue" optionLabel="name" optionValue="value"
                    (onChange)="dateRangeChange($event,false)"></p-dropdown>
                <img src="../../../../assets/images/fill-dropdown.svg" alt=""/>
            </div>
            <div class="date-range-outer">
            <div class="date-input" *ngIf="dateRangeValue === 1">
                <p-calendar #calendarTopStartDateRef [(ngModel)]="start" dateFormat="M dd, yy"
                    [inputStyle]="{'width':'95%'}" [readonlyInput]="true" placeholder="Select Date"
                    [placeholder]="start" (onSelect)="onStartDateChange()"></p-calendar><img [calendarOpener]="calendarTopStartDateRef"
                    src="assets/images/date-calender.png" alt="calender" />
            </div>
            <div class="from-date">
                <div class="date-input" *ngIf="dateRangeValue === 1"> <span>To</span>
                    <p-calendar #calendarTopEndDateRef [(ngModel)]="end" dateFormat="M dd, yy"
                        [inputStyle]="{'width':'95%'}" placeholder="Select Date" [placeholder]="end"
                        [readonlyInput]="true" [minDate]="minEndDate"></p-calendar><img [calendarOpener]="calendarTopEndDateRef"
                        src="assets/images/date-calender.png" alt="calender" />
                </div>
                <div class="filter-btn apply-btn">
                    <p-button (onClick)="searchFunc(start,end)" label="Apply"></p-button>
                </div>
                <div class="filter-btn apply-btn">
                    <p-button styleClass="p-button p-button-outlined" (onClick)="resetfilter(true)" label="Reset"  class=""></p-button>
                </div>
            </div>
        </div>
        </div>
    </div>
</div>   